module.exports = __webpack_public_path__ + "static/media/espace_professors.1a2bf3ed.png";